import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Check, Sparkles } from 'lucide-react';
export function InvestmentSection() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });
  return <section className="relative py-16 sm:py-20 md:py-24 px-5 sm:px-6 bg-black" data-id="element-549" data-mp="1j2kko955x7rt">
      <motion.div ref={ref} initial={{
      opacity: 0,
      y: 30
    }} animate={inView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.8
    }} className="max-w-6xl mx-auto" data-id="element-550" data-mp="1j4ozvn8iht7e">
        <div className="text-center mb-12 sm:mb-16" data-id="element-551" data-mp="2btm5aprmjviq">
          <h2 className="text-3xl sm:text-5xl md:text-6xl font-serif font-bold text-stone-100 mb-6 sm:mb-8" style={{
          fontFamily: 'Cinzel, serif'
        }} data-id="element-552" data-mp="26z8fd2vqeglg">
            Your Investment
          </h2>
          <p className="text-lg sm:text-xl text-stone-400 max-w-2xl mx-auto" data-id="element-553" data-mp="2zif3ksvpyfgi">
            One simple month-to-month membership. Cancel anytime.
          </p>
        </div>

        <div className="max-w-md mx-auto" data-id="element-554" data-mp="13suytkv6d18v">
          <div className="relative bg-gradient-to-br from-amber-950/40 to-black border-2 border-amber-500 p-6 sm:p-8 rounded-xl shadow-[0_0_16px_rgba(217,119,6,0.16)] sm:shadow-[0_0_30px_rgba(217,119,6,0.2)]" data-id="element-555" data-mp="13v7q4omtonyl">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-amber-500 text-black px-4 py-1 rounded-full text-xs sm:text-sm font-bold whitespace-nowrap" data-id="element-556" data-mp="u1h37o6cgll0">
              PSI PRO MEMBERSHIP
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-stone-100 mb-2 mt-2" data-id="element-557" data-mp="p3yt3uglc0bf">
              Monthly Membership
            </h3>
            <div className="flex items-baseline gap-2 mb-6" data-id="element-558" data-mp="b5h8i5lzf3xq">
              <span className="text-3xl sm:text-4xl font-bold text-amber-500" data-id="element-559" data-mp="g3io2gk78l4g">
                $249
              </span>
              <span className="text-stone-400" data-id="element-560" data-mp="25i736pk6ch66">/month</span>
            </div>
            <ul className="space-y-3 sm:space-y-4 mb-8" data-id="element-561" data-mp="2ahjrzfulvybe">
              <li className="flex items-start gap-3 text-stone-300 text-sm sm:text-base" data-id="element-562" data-mp="2ah1n5utvobrv">
                <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-563" data-mp="284g6w8zqtf4n" />
                <span data-id="element-564" data-mp="2408eo1u2th1o">Full Access to PSI PRO</span>
              </li>
              <li className="flex items-start gap-3 text-stone-300 text-sm sm:text-base" data-id="element-565" data-mp="1z1yipp0j2cf0">
                <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-566" data-mp="1u33s40wbjjkc" />
                <span data-id="element-567" data-mp="1u586xdvra2ze">Peptide Mastery 2.0 Modules Unlock Monthly</span>
              </li>
              <li className="flex items-start gap-3 text-stone-300 text-sm sm:text-base" data-id="element-568" data-mp="2rq2osbn0gri8">
                <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-569" data-mp="2msax9iqa37ek" />
                <span data-id="element-570" data-mp="2hzrn6vqsuuei">Live Monthly Sessions</span>
              </li>
              <li className="flex items-start gap-3 text-stone-300 text-sm sm:text-base" data-id="element-571" data-mp="2d29e95cs8f6i">
                <Sparkles className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" data-id="element-572" data-mp="3ah3o50s1mp2b" />
                <span data-id="element-573" data-mp="3aj6pui2k66mv">Full Unlock Option Available Later</span>
              </li>
              <li className="flex items-start gap-3 text-stone-300 text-sm sm:text-base" data-id="element-574" data-mp="35pc7pj2lpzpw">
                <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-575" data-mp="3d3cukryzy14h" />
                <span data-id="element-576" data-mp="3i1o1attzvvih">Cancel Anytime — No Contract</span>
              </li>
            </ul>
            <a href="https://go.peptidescienceinstitute.com/pm-pro-monthly-fm" className="block w-full py-3 sm:py-4 text-center bg-amber-500 text-black font-bold rounded-lg hover:bg-amber-400 transition-all duration-300 shadow-lg hover:shadow-amber-500/25 min-h-[44px]" data-id="element-577" data-mp="3myxyivnmlbgv">
              Join Monthly
            </a>
          </div>
        </div>
      </motion.div>
    </section>;
}